<template>
    <v-dialog v-model="dialog" max-width="900" eager persistent>
        <v-card>
            <v-card-title>
                {{ $t('memberEdit:title') }}
            </v-card-title>

            <v-card-text>
                <MemberEdit ref="memberEditRef" @modified="dialog = false" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from 'vue'
import MemberEdit from '../components/MemberEdit.vue'


const dialog = ref(false)
const memberEditRef = ref(null)

async function showIfInvalid(member) {
    memberEditRef.value.setMember(member);    
    const validation = await memberEditRef.value.isValid();
    if (!validation.valid) {
        dialog.value = true;
    }

}

defineExpose({
    showIfInvalid
})


</script>

<style scoped></style>